const errorTypesText = {
  invalidEmail: 'Please enter a valid email address.',
  invalidChar: 'Special characters are restricted.',
  invalidPhone: 'Please enter a valid phone number.',
  invalidAddress: 'Please enter a valid address.',
  invalidResponse: 'Please enter a valid response.',
  invalidRegistryNum: 'Please enter a valid registry number.',
  invalidReceiptNum: 'Please enter a valid receipt number.',
  invalidZip: 'Please enter a valid zip code.',
  invalidFName: 'Please enter a valid first name.',
  invalidLName: 'Please enter a valid last name.',
  invalidPopNum: 'Please enter a valid POP number.',

  tooLong: 'Character limit reached.',
  tooShort: 'Please enter the minimum character amount.',
  tooShortPhone: 'Phone requires at least 10 numbers.',
  tooShortEmail: 'Email requires at least 5 characters.',
  tooShortFName: 'First name requires at least 2 characters.',
  tooShortLName: 'Last name requires at least 2 characters.',
  tooShortCity: 'City requires at least 3 characters.',
  tooShortZip: 'Zip code requires at least 5 or 9 numbers.',
  tooShortAddress: 'Address requires at least 2 characters.',

  required: 'This field is required.',
  requiredSelect: 'Please select a response.',
  requiredState: 'State is required.',
  requiredStore: 'Store location is required.',
  requiredFName: 'First name is required.',
  requiredLName: 'Last name is required.',
  requiredFeedback: 'Please enter your comments.',
  requiredRating: 'A rating is required.',
  requiredZip: 'Zip is required.',
  requiredRegistryNum: 'Registry number is required.',
  requiredReceiptNum: 'Receipt number is required.',
  requiredPhone: 'Phone number is required.',
  requiredDate: 'Please select a date.',
  requiredAddress: 'Address is required.',
  requiredEmail: 'Email is required.',
  requiredCity: 'City is required.',
  requiredPopNum: 'POP number is required.',
  requiredTimeSlot: 'Please select a time slot.',
  requiredAnswer: 'Please select an option.',
  requiredEventId: 'EventId is invalid.',
  requiredMessage: 'Please enter a message.',
};

// ********** RULES TO VALIDATE AGAINST *************
//? If object to validate exists but key is different
//? than name attribute, add name to aliases.
//? Otherwise, add to list of rules.
const validationRules = {
  email: {
    min: 5,
    max: 50,
    pattern:
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 50`,
      tooShort: errorTypesText.tooShortEmail,
      invalid: errorTypesText.invalidEmail,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredEmail,
    },
  },
  firstName: {
    min: 2,
    max: 15,
    // letters and ' and -
    pattern: "[a-z A-Z\-']",
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 15`,
      tooShort: errorTypesText.tooShortFName,
      invalid: errorTypesText.requiredFName,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredFName,
    },
  },
  lastName: {
    min: 2,
    max: 25,
    // letters and ' and -
    pattern: "[a-z A-Z\-']",
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 25`,
      tooShort: errorTypesText.tooShortLName,
      invalid: errorTypesText.requiredLName,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredLName,
    },
  },
  city: {
    min: 3,
    max: 20,
    // doing same as address, should probably change
    pattern: '[a-z A-Z 0-9\#\/]',
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 20`,
      tooShort: errorTypesText.tooShortCity,
      invalid: errorTypesText.invalidResponse,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredCity,
    },
  },
  phone: {
    min: 10,
    max: 14,
    // numbers only
    pattern: /^[0-9]*$/,
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 10`,
      tooShort: errorTypesText.tooShortPhone,
      invalid: errorTypesText.invalidPhone,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredPhone,
    },
  },
  zip: {
    min: 5,
    max: 10,
    // numbers only
    pattern: '^[0-9]{5}(?:-[0-9]{4})?$',
    pattern2: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    errorMsg: {
      tooLong: `${errorTypesText.tooLong}`,
      tooShort: errorTypesText.tooShortZip,
      invalid: errorTypesText.invalidZip,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredZip,
    },
  },
  address: {
    min: 2,
    max: 60,
    // letters, numbers, #, /
    pattern: '[\- a-z A-Z 0-9\#\/]',
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 60`,
      tooShort: errorTypesText.tooShortAddress,
      invalid: errorTypesText.invalidAddress,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredAddress,
    },
  },
  long: {
    min: 1,
    max: 1000,
    // any are allowed
    pattern: '',
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 1000`,
      tooShort: errorTypesText.tooShort,
      required: errorTypesText.requiredFeedback,
    },
  },
  short: {
    min: 1,
    max: 200,
    // any are allowed
    pattern: '',
    errorMsg: {
      tooLong: `${errorTypesText.tooLong} Max length: 200`,
      tooShort: errorTypesText.tooShort,
      required: errorTypesText.required,
    },
  },
  registryNum: {
    min: 9,
    max: 9,
    // numbers only
    pattern: /^[0-9]*$/,
    errorMsg: {
      tooLong: errorTypesText.tooLong,
      tooShort: errorTypesText.tooShort,
      invalid: errorTypesText.invalidRegistryNum,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredRegistryNum,
    },
  },
  receiptNum: {
    min: 19,
    max: 19,
    // numbers only
    pattern: /^[0-9]*$/,
    errorMsg: {
      tooLong: errorTypesText.tooLong,
      tooShort: errorTypesText.tooShort,
      invalid: errorTypesText.invalidReceiptNum,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredReceiptNum,
    },
  },
  popNumber: {
    min: 12,
    max: 12,
    // numbers only
    pattern: /^[0-9]*$/,
    errorMsg: {
      tooLong: errorTypesText.tooLong,
      tooShort: errorTypesText.tooShort,
      invalid: errorTypesText.invalidReceiptNum,
      invalidChar: errorTypesText.invalidChar,
      required: errorTypesText.requiredPopNum,
    },
  },
  state: {
    min: 2,
    max: 30,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredState,
    },
  },
  storeNum: {
    min: 2,
    max: 4,
    pattern: /^[0-9]*$/,
    errorMsg: {
      required: errorTypesText.requiredStoreNum,
    },
  },
  options: {
    min: 2,
    max: 100,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredStore,
    },
  },
  select: {
    min: 1,
    max: 100,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredSelect,
    },
  },
  yn: {
    min: 1,
    max: 1,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredSelect,
    },
  },
  star: {
    min: 1,
    max: 1,
    pattern: /^[0-9]*$/,
    errorMsg: {
      required: errorTypesText.requiredRating,
    },
  },
  date: {
    min: 1,
    max: 100,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredDate,
    },
  },
  startDateMs: {
    min: 1,
    max: 100,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredTimeSlot,
    },
  },
  selectedAnswers: {
    min: 1,
    max: 100,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredAnswer,
    },
  },
  eventId: {
    min: 1,
    max: 30,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredEventId,
    },
  },
  senderMessage: {
    min: 1,
    max: 200,
    pattern: '[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\?\\.\\,\\[\\]\\#\\"\' ]',
    errorMsg: {
      required: errorTypesText.requiredMessage,
    },
  },
  services: {
    min: 1,
    max: 200,
    pattern: '',
    errorMsg: {
      required: errorTypesText.requiredMessage,
    },
  },
  aliases: {
    contactState: 'state',
    address1: 'address',
    address2: 'address',
    rtn_receiptNumber: 'receiptNum',
    rtn_popNumber: 'popNumber',
    store: 'storeNum',
    storeDD: 'storeNum',
    stateDD: 'state',
    OPT: 'options',
    opt: 'options',
    YN: 'yn',
    recipName: 'lastName',
    recipEmail: 'email',
    recipEmailConfirm: 'email',
    senderName: 'lastName',
    senderMessage: 'short',
    selectedAttrVal: 'select',
    selectedImage: 'select',
    intl: 'select',
    stateCode: 'state',
    response1: 'select',
    response2: 'select',
    fname: 'firstName',
    lname: 'lastName',
    dob: 'date',
    comment: 'long',
    userChoice: 'services',
  },
};

//! -------------------------------------------------------
//! -------- SEE VALIDATEINPUT FOR HOW TO USE -------------
//! -------------------------------------------------------

// ***react feedback uses the following three functions,
// ***don't modify unless refactoring both.
// probably need to refactor them to use the latest version of this file...
const emailValidation = (value) => {
  const isValidEmail = value.includes('@') && value.includes('.') && value.length >= 3 && value.length <= 200;
  return isValidEmail;
};

const contentValidation = (value, type) => {
  if (type === 'email') {
    return emailValidation(value);
    // validate character length
    // api can only take 1000 max for type long
    // and 200 max for type short
  } else if (
    value.length >= 1 &&
    ((type === 'SHORT' && value.length <= 200) || (type === 'LONG' && value.length <= 1000))
  ) {
    return true;
  } else if (type === 'STAR' || type === 'OPT' || type === 'STORE' || type === 'Y' || type === 'N') {
    return true;
  }
  return false;
};

const validChars = (val, type) => {
  if (type === 'email') {
    // do strip chars or something cool in here
    return val;
  } else if (type === 'comment') {
    // do more strip chars or something cool in here
    return val;
  } else {
    return val;
  }
};

const stripServerProhibitedCharactersOnly = (input) => {
  var filteredValues = '<>{}',
    result = '',
    x;

  for (x = 0; x < input.length; x++) {
    var currentChar = input.charAt(x).replace('/', '-');
    if (filteredValues.indexOf(currentChar) === -1) result += currentChar;
  }

  return result;
};

// strips characters
const removeSpecialChars = (input, pattern) => {
  var result = '',
    x;
  var focusPattern = '0';
  focusPattern = pattern;

  // WWW-18510 - stop user from entering more than 1 # at a time
  var checkHash = 0;
  for (x = 0; x < input.length; x++) {
    var currentChar = input.charAt(x);
    var currentCharAscii = input.charCodeAt(x);
    var lastChar = input.charAt(x - 1);
    var lastCharAscii = input.charCodeAt(x - 1);
    var twoCharsBack = input.charAt(x - 2);
    var twoCharsBackAscii = input.charCodeAt(x - 2);
    //iOS smart punctuation characters for apostrophe and single quote
    if (currentCharAscii == '8216' || currentCharAscii == '8217') {
      currentChar = "'";
    }

    //iOS smart punctuation characters for double quotes...(ง'̀-'́)ง darn you ios
    if (currentCharAscii == '8220' || currentCharAscii == '8221') {
      currentChar = '"';
    }
    //only allow 1 # at a time
    if (currentChar == '#') {
      if (lastChar == '#') {
        currentChar = '';
      }
    }
    if (currentChar.search(focusPattern) > -1) result += currentChar;
  }
  if (result.trim() == '') result = '';
  //remove spaces around / slashes
  if (input.length >= 3) {
    if (currentCharAscii == 47 && lastCharAscii == 32) {
      _;
      result = input.split(' /').join('/');
    }
    if (twoCharsBackAscii == 47 && lastCharAscii == 32) {
      result = input.split('/ ').join('/');
    }
  }

  return result;
};

const removeAllButNums = (input) => {
  return input.replace(/[^0-9]/g, '');
};

const isValidEmail = (testString) => {
  var regEx = validationRules.email.pattern;
  if (regEx.test(testString)) {
    if (testString.indexOf('@-') > 0 || testString.indexOf('-.') > 0) {
      return false;
    }
  }
  return regEx.test(testString);
};

//? ***************** End Char Functions ********************

//? -------------------------------------------------------------------
//? -------------- PASS IN INPUT VALUE && NAME && REQUIRED ------------
//? -------------------------------------------------------------------
//? ------ NAME ATTRIBUTE SHOULD MATCH VALIDATIONRULES OBJ KEY --------
//? -------------------------------------------------------------------

//? ---------------- validate on blur -----------------
const validateInputOnBlur = (value, name, required) => {
  const length = value.length;

  // ********* If name is not associated with the rule, **********
  // ****** add name as key and rule as value to aliases *********
  const validationName = validationRules[name] ? name : validationRules.aliases[name];

  // Finds the rule associated with name.
  const rule = validationRules[validationName];

  if (!rule) {
    throw new Error(
      `Please check the name attribute: '${name}', it may need to added to the list of aliases. Please see validationRules`
    );
  }

  const isRequired = required ?? false;
  let valid = true;
  let errText = undefined;

  if (length > rule.max) {
    valid = false;
    errText = rule.errorMsg.tooLong;
  }

  if (length < rule.min && length > 0) {
    valid = false;
    errText = rule.errorMsg.tooShort;
  }

  if (length === 0 && isRequired) {
    valid = false;
    errText = rule.errorMsg.required;
  }

  // email gets ~special~ treatment
  if (validationName === 'email' && (value.length > 0 || required)) {
    if (!isValidEmail(value)) {
      valid = false;
      errText = rule.errorMsg.invalid;
    }
  }

  // state gets ~special~ treatment
  if (validationName === 'state' || validationName === 'storeNum') {
    if (value === '' || value === '*') {
      valid = false;
      errText = rule.errorMsg.required;
    } else {
      valid = true;
    }
  }

  // zip gets ~special~ treatment
  if (name === 'zip') {
    if (value.includes('_')) {
      valid = false;
      errText = rule.errorMsg.invalid;
    }
    const pat = new RegExp(rule.pattern);
    if (!pat.test(value)) {
      valid = false;
      errText = rule.errorMsg.invalid;
    }
  }

  if (name === 'phone' && length !== rule.min && length !== rule.max) {
    valid = false;
    errText = rule.errorMsg.invalid;
  }

  if (validationName === 'select' && value === '*') {
    valid = false;
  }

  // return object
  const validObj = {
    valid: valid,
    errorMsg: errText,
  };

  return validObj;
};

//? ------------ validate on input --------------
const validateInputOnInput = (value, name, required) => {
  const validationName = validationRules[name] ? name : validationRules.aliases[name];
  const rule = validationRules[validationName];

  let newValue = value;

  if (!rule) {
    throw new Error(
      `Please check the name attribute: '${name}', it may need to added to the list of aliases. Please see validationRules`
    );
  }

  const reg = new RegExp(rule.pattern);

  // if value isn't included in pattern, strip character
  // don't strip these fields tho
  if (
    validationName !== 'zip' &&
    validationName !== 'phone' &&
    validationName !== 'email' &&
    validationName !== 'receiptNum' &&
    validationName !== 'star' &&
    validationName !== 'date'
  ) {
    newValue = removeSpecialChars(value, reg);
  }

  if (validationName === 'zip' || validationName === 'phone' || validationName === 'receiptNum') {
    newValue = removeAllButNums(value);
  }

  const validObj = {
    value: newValue,
  };

  return validObj;
};

export {
  errorTypesText,
  emailValidation,
  contentValidation,
  validChars,
  validateInputOnBlur,
  validateInputOnInput,
  validationRules,
};
